import React from 'react';
import classNames from 'classnames/bind';
import styles from './assets/styles.scss';
import RacesBanner from './RacesBanner';
import PartnersBanner from './PartnersBanner';
import PromotionsBanner from './PromotionsBanner';
import { useMobileOnly } from '../../../helpers/responsive';

const cx = classNames.bind(styles);

export default function BannerGrid() {
  const isMobileOnly = useMobileOnly();

  return (
    <div className={cx('banner-grid')}>
      <RacesBanner />
      <PartnersBanner isMobileOnly={isMobileOnly} />
      <PromotionsBanner isMobileOnly={isMobileOnly} />
    </div>
  );
}
